import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment.prod';
import { Observable } from 'rxjs';

export type Lang = 'geo' | 'eng';

export interface FooterSection {
  id: number;
  lang: Lang;
  title: string;
  sort: number;
  visible: number; // 0/1
  created_at?: string;
  updated_at?: string;
}

export type FooterItemType = 'text' | 'phone' | 'email' | 'link' | 'social' | 'hours' | 'address';

export interface FooterItem {
  id: number;
  section_id: number;
  type: FooterItemType;
  label?: string | null;
  value?: string | null;
  url?: string | null;
  icon?: string | null;
  target: number; // 0 self, 1 blank
  sort: number;
  visible: number;
  created_at?: string;
  updated_at?: string;
}

@Injectable({
  providedIn: 'root'
})
export class SettingService {
  
  private api = environment.apiUrl; // მაგალითად: https://api.sca.ge/api/

  constructor(private http: HttpClient) {}

  // Sections
  sections(lang: Lang) {
    return this.http.get<{ status: string; data: FooterSection[] }>(
      `${this.api}admin/footer/sections`,
      { params: { lang } }
    );
  }

  sectionShow(id: number, lang: Lang) {
    return this.http.get<{ status: string; data: { section: FooterSection; items: FooterItem[] } }>(
      `${this.api}admin/footer/sections/${id}`,
      { params: { lang } }
    );
  }

  sectionCreate(payload: Partial<FooterSection>, lang: Lang) {
    return this.http.post<{ status: string; data: FooterSection }>(
      `${this.api}admin/footer/sections`,
      payload,
      { params: { lang } }
    );
  }

  sectionUpdate(id: number, payload: Partial<FooterSection>, lang: Lang) {
    return this.http.post<{ status: string; data: FooterSection }>(
      `${this.api}admin/footer/sections/${id}`,
      payload,
      { params: { lang } }
    );
  }

  sectionToggleVisible(id: number, lang: Lang) {
    return this.http.post<{ status: string; data: { visible: number } }>(
      `${this.api}admin/footer/sections/${id}/toggle-visible`,
      {},
      { params: { lang } }
    );
  }

  sectionSort(ids: number[], lang: Lang) {
    return this.http.post<{ status: string }>(
      `${this.api}admin/footer/sections/sort`,
      { ids },
      { params: { lang } }
    );
  }

  sectionDelete(id: number, lang: Lang, soft = false) {
    return this.http.post<{ status: string; message: string }>(
      `${this.api}admin/footer/sections/${id}/delete`,
      { soft },
      { params: { lang } }
    );
  }

  // Items
  items(sectionId: number, lang: Lang) {
    return this.http.get<{ status: string; data: FooterItem[] }>(
      `${this.api}admin/footer/sections/${sectionId}/items`,
      { params: { lang } }
    );
  }

  itemCreate(sectionId: number, payload: Partial<FooterItem>, lang: Lang) {
    return this.http.post<{ status: string; data: FooterItem }>(
      `${this.api}admin/footer/sections/${sectionId}/items`,
      payload,
      { params: { lang } }
    );
  }

  itemUpdate(id: number, payload: Partial<FooterItem>, lang: Lang) {
    return this.http.post<{ status: string; data: FooterItem }>(
      `${this.api}admin/footer/items/${id}`,
      payload,
      { params: { lang } }
    );
  }

  itemToggleVisible(id: number, lang: Lang) {
    return this.http.post<{ status: string; data: { visible: number } }>(
      `${this.api}admin/footer/items/${id}/toggle-visible`,
      {},
      { params: { lang } }
    );
  }

  itemSort(sectionId: number, ids: number[], lang: Lang) {
    return this.http.post<{ status: string }>(
      `${this.api}admin/footer/items/sort`,
      { section_id: sectionId, ids },
      { params: { lang } }
    );
  }

  itemDelete(id: number, lang: Lang, soft = false) {
    return this.http.post<{ status: string; message: string }>(
      `${this.api}admin/footer/items/${id}/delete`,
      { soft },
      { params: { lang } }
    );
  }
  
}